export default theme => ({
  root: {
    padding: theme.spacing(0)
  },
  content: {
    padding: theme.spacing(0),
    backgroundColor: '#f8fafc'
  }
});
